import styled from 'styled-components'

export const Button = styled.a.attrs(() => ({
  target: '_blank',
  rel: 'noopener noreferrer',
}))`
  display: flex;
  align-items: center;
  min-width: 216px;
  max-width: 720px;
  color: #2a2e3d;
  background-color: #c8dfe3;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
  padding: 8px 24px;
  text-decoration: none;
  text-align: center;
  border-radius: 100px;

  svg {
    margin-left: 8px;
  }
`
